/* eslint-disable react/sort-comp */
/* eslint-disable import/order */
import AppBar from '@material-ui/core/AppBar'
import Dialog from '@material-ui/core/Dialog'
import IconButton from '@material-ui/core/IconButton'
import withStyles from '@material-ui/core/styles/withStyles'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import React, { useEffect, useMemo } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'

import styles from '../../../../resources/theme/users'
import { edit, getPermission, update } from '../../AttendanceActions'
import Form from '../Form'
import { bindActionCreators } from 'redux'
import { Box, Button, Chip, Grid, makeStyles, Slide } from '@material-ui/core'
import BaseCreatePage from '../../../../components/hooks/BaseCreatePage'
import { mdiCalendarMultiple, mdiNoteEditOutline } from '@mdi/js'
import Icon from '@mdi/react'
import {
  Link,
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'
import colors from '../../../../assets/colors'
import {
  dateFormatedFullDate,
  exportFormatedMoney,
  phoneMask,
} from '../../../../util/utils'
import Calendar from '../Calendar'
import BaseFilterModal from '../../../../components/hooks/BaseFilterModal'
import ServiceItemsTable from '../../../crm/panel/pages/lead/ServiceItemsTable'
import { HeaderInfo } from './HeaderInfo'
import ItemsTable from './ItemsTable'
import filterStylesComponents from '../../../../assets/filterComponentsStyles'

const useStyles = makeStyles({
  rowMessage: {
    padding: '8px 0',
    borderTop: '1px dashed',
    borderColor: colors.textSecondary,
    borderBottom: '1px dashed',
    borderBottomColor: colors.textSecondary,
    color: colors.textPrimary,
    fontSize: '14px',
  },
  message: {
    padding: '8px 0',
    borderTop: '1px dashed',
    borderColor: colors.textSecondary,
    borderBottom: '1px dashed',
    borderBottomColor: colors.textSecondary,
    color: colors.textPrimary,
    fontSize: '14px',
  },
  btnCalendar: {
    color: '#FFFF',
    fontSize: '14px',
    backgroundColor: colors.primary,
    borderRadius: '10px',
    padding: '4px 12px',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      opacity: 0.6,
      backgroundColor: colors.primary,
    },
  },
  cardSubTitles: {
    color: colors.primary,
    fontSize: '16px',
    lineHeight: '16px',
    fontWeight: 'bold',
    margin: '10px 0',
  },
  box: {
    padding: '8px 0 8px 0',
    borderBottom: `1px dashed ${colors.graylight}`,
    color: colors.gray,
  },
  serviceContainer: {
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: '250px',
    paddingRight: '8px',
    '&::-webkit-scrollbar': {
      width: '3px',
      height: '8px',
      backgroundColor: colors.graylight,
    },
    '&::-webkit-scrollbar-thumb': {
      background: colors.secondary,
    },
  },
})

export const Visualization = props => {
  const attendance = useSelector(state => state.attendance.editingAttendance)

  const history = useHistory()
  const dispatch = useDispatch()

  const styles = useStyles()
  const filterStyles = filterStylesComponents()

  const { match } = props

  const id = useMemo(() => {
    return match?.params?.id
  }, [match])

  const handleClose = () => {
    history.goBack()
  }

  useEffect(() => {
    dispatch(edit(id))
  }, [id])

  return (
    <BaseFilterModal
      open
      title={`Visualização | OS: ${
        attendance?.id_laundry_client || 'Carregando'
      }`}
      hiddenHelpButton
      handleOpen={handleClose}
    >
      <Grid item xs={12} style={{ width: '700px' }}>
        <Grid container spacing={2}>
          {!attendance && (
            <Grid item xs={12}>
              <Typography className="MuiDropzoneArea-icon ">
                Carregando atendimento...
              </Typography>
            </Grid>
          )}

          {attendance?.loss_reason && (
            <Grid item xs={12}>
              <Grid container spacing={2} alignItems="center">
                <Box
                  item
                  xs={12}
                  style={{
                    padding: '4px',
                    display: 'flex',
                    width: '100%',
                    alignItems: 'center',
                    gap: '4px',
                    color: colors.error,
                    borderRadius: '8px',
                    backgroundColor: colors.bgError,
                  }}
                >
                  <Typography style={{ fontWeight: 'bold' }}>
                    Motivo de cancelamento:
                  </Typography>

                  <Typography>{attendance?.loss_reason}</Typography>
                </Box>
              </Grid>
            </Grid>
          )}

          {attendance && (
            <>
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Grid container>
                      <Grid item xs={12} className={styles.box}>
                        <Grid container justifyContent="space-between">
                          <Grid item>
                            <HeaderInfo
                              label="Vendedor:"
                              info={attendance?.user?.name}
                            />
                          </Grid>

                          <Grid item>
                            <HeaderInfo
                              label="Criado em:"
                              info={dateFormatedFullDate(
                                attendance?.created_at
                              )}
                            />
                          </Grid>

                          <Grid item>
                            <HeaderInfo
                              label="Valor:"
                              info={exportFormatedMoney(
                                attendance?.final_value_discount
                              )}
                            />
                          </Grid>

                          <Grid item>
                            <Chip
                              size="small"
                              label={attendance?.status?.name}
                              style={{
                                backgroundColor: attendance?.status?.color,
                                borderRadius: '8px',
                                fontSize: '14px',
                                color: '#FFFF',
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12}>
                    <Grid container>
                      <Grid item xs={12} className={styles.box}>
                        <Grid container>
                          <Grid item xs={12}>
                            <Typography className={styles.cardSubTitles}>
                              Informações do cliente:
                            </Typography>
                          </Grid>

                          <Grid item xs={12}>
                            <Grid container justifyContent="space-between">
                              <Grid item>
                                <HeaderInfo
                                  label="Nome:"
                                  info={attendance?.client?.name}
                                />
                              </Grid>

                              <Grid item>
                                <HeaderInfo
                                  label="Email:"
                                  info={
                                    attendance?.client?.email ||
                                    'Cliente sem email.'
                                  }
                                />
                              </Grid>

                              <Grid item>
                                <HeaderInfo
                                  label="Telefone:"
                                  info={phoneMask(
                                    attendance?.client?.phone || ''
                                  )}
                                />
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12} style={{ paddingTop: '4px' }}>
                            <Typography>
                              {`${attendance?.client?.street}, ${
                                attendance?.client?.number || 'N/A'
                              } - ${attendance?.client?.neighborhood} ${
                                attendance?.client?.cep
                              } ${attendance?.client?.city} - ${
                                attendance?.client?.uf
                              }`}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12}>
                    <Grid container>
                      <Grid item xs={12}>
                        <Grid container alignItems="center" spacing={2}>
                          <Grid item>
                            <Typography className={styles.cardSubTitles}>
                              Serviços
                            </Typography>
                          </Grid>

                          <Grid item xs>
                            <Box
                              style={{
                                width: '100%',
                                border: '1px solid',
                                borderColor: colors.primary,
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={12} className={styles.serviceContainer}>
                        <ItemsTable items={attendance?.services} />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12}>
                    <Grid container>
                      <Grid item xs={12} className={styles.box}>
                        <Grid container spacing={1}>
                          <Grid item xs={12}>
                            <Typography style={{ color: colors.textGray }}>
                              Observações da Os
                            </Typography>
                          </Grid>

                          <Grid item xs={12}>
                            <Typography style={{ color: colors.textGray }}>
                              {attendance?.general_service_observations}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} style={{ marginTop: '1em' }}>
                    <Grid container justifyContent="space-between">
                      <Grid item>
                        <IconButton
                          component={Link}
                          className={filterStyles.btnAdd}
                          to={`/attendance/${id}/edit`}
                        >
                          <Icon
                            path={mdiNoteEditOutline}
                            size={1}
                            style={{ marginRight: '4px' }}
                          />
                          Navegar para Edição
                        </IconButton>
                      </Grid>

                      <Grid item>
                        <Button
                          className={filterStyles.btnSalvar}
                          onClick={handleClose}
                        >
                          Fechar
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </BaseFilterModal>
  )
}
